import React from 'react';

import TranslateIcon from '@mui/icons-material/Translate';

import { ILanguage } from '../../../../types/interfaces/language';
import AppEntityAvatar, {
  AppEntityAvatarProps,
} from '../app-entity-avatar/AppEntityAvatar';

interface AppLanguageAvatarProps extends AppEntityAvatarProps {
  language?: ILanguage;
}

export default function AppLanguageAvatar(props: AppLanguageAvatarProps) {
  const { language, ...avatarProps } = props;

  return (
    <AppEntityAvatar
      {...avatarProps}
      fallbackSeedId={language?.id}
      fallbackSeedName={language?.title}
      directPreviewStorageLink={language?.avatar?.directPreviewStorageLink}
      directStorageLink={language?.avatar?.directStorageLink}
      previewStorageLink={language?.avatar?.previewStorageLink}
      storageLink={language?.avatar?.storageLink}>
      <TranslateIcon />
    </AppEntityAvatar>
  );
}
